import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import virtolyLogoWebp from '../../assets/images/virtoly-logo.webp';
import virtolyLogoPng from '../../assets/images/virtoly-logo.png';

/** Intrinsic dimensions of virtoly-logo source (409×610) — reserve space to prevent CLS. */
export const VIRTOLY_LOGO_INTRINSIC_WIDTH = 409;
export const VIRTOLY_LOGO_INTRINSIC_HEIGHT = 610;

const logoImgSx: SxProps<Theme> = {
    height: { xs: 28, sm: 33, md: 37 },
    width: 'auto',
    objectFit: 'contain',
    display: 'block',
    flexShrink: 0,
};

type VirtolyLogoProps = {
    alt: string;
    sx?: SxProps<Theme>;
};

/** Logo with explicit dimensions and WebP delivery for LCP/CLS. */
export function VirtolyLogo({ alt, sx }: VirtolyLogoProps) {
    return (
        <Box
            sx={[
                { display: 'block', flexShrink: 0, lineHeight: 0, '& .virtoly-logo-img': logoImgSx },
                ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
            ]}
        >
            <picture>
                <source srcSet={virtolyLogoWebp} type="image/webp" />
                <img
                    src={virtolyLogoPng}
                    alt={alt}
                    width={VIRTOLY_LOGO_INTRINSIC_WIDTH}
                    height={VIRTOLY_LOGO_INTRINSIC_HEIGHT}
                    decoding="async"
                    className="virtoly-logo-img"
                />
            </picture>
        </Box>
    );
}
